import React, { useEffect, useState } from 'react';
import { Container, Card, Button, Modal, Row, Col, Alert, Spinner } from 'react-bootstrap';
import PlanService from '../../service/PlanService';
import EmailService from '../../service/EmailService';
import SlimAd from '../../assets/diamond-slim-ad.webp';

const Plans = () => {
  const [plans, setPlans] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', formMessage: '' });
  const [message, setMessage] = useState({ text: '', variant: '' });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await PlanService.getAllPlans();
      setPlans(response);
    } catch (error) {
      console.error('Error fetching plans:', error);
    }
  };

  const handleShow = (plan) => {
    setSelectedPlan(plan);
    setShowModal(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ text: '', variant: '' });

    try {
      const response = await EmailService.sendEmail(formData);
      setMessage({ text: [response], variant: 'success' });
      setFormData({ name: '', email: '', phone: '', formMessage: '' });
    } catch (error) {
      setMessage({ text: `Error: ${error.message}`, variant: 'danger' });
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => setShowModal(false);

  return (
    <>
      <section className="plan-section">
        <Container>
          <Row>
            <div className="plan_title">
              <h2 className="text-center">Transparent Pricing Plans <br/>Built For Your Roadside Needs</h2>
              <p className="text-center">
                Choose affordable, flexible, and reliable towing packages designed to deliver value,
                <br/>safety, and peace of mind for every driver, anytime and anywhere.
              </p>
            </div>
          </Row>

          {/* Directly render the plan content without tabs */}
          <Row className="mt-lg-5 mt-3 plan_content justify-content-center">
            {plans.map((plan) => (
              <Col lg={3} md={5} className='mb-lg-0 mb-3' key={plan.id}>
                <Card className="text-start border-blk rounded-0">
                  <Row className="mx-0">
                    {plan.imageName && (
                      <Col md={12} className="align-content-around p-0">
                        <Card.Img variant="top" className='rounded-0' src={plan.imageName} alt={plan.name} />
                      </Col>
                    )}

                    <Col className='px-0' md={12}>
                      <Card.Body className='planCard-style position-relative'>
                        <Row>
                          <div className='col-md-12 d-xl-flex align-items-center justify-content-between mb-md-3 mb-2'>
                            <div className='home_plan_price'>
                              <h5>{plan.name} Plan </h5>
                            </div>
                            <div className='home_plan_price'>
                              <h3><sup>$</sup>{plan.price}<span> / Per Month</span></h3>
                            </div>
                          </div>

                          <div className='col-md-12'>
                            <div className='row justify-content-between align-items-center'>
                              <div className='cardText col-md-5 col-6'>
                                <span className='ad_miles'>0.0 Miles</span>
                              </div>

                              <div className='cardText col-md-7 col-6'>
                                <h6 className='ad_worktype ml-auto'><b>Shop/Mobile</b></h6>
                              </div>

                              <div className='cardText col-md-12'>
                                <Card.Title>Your Company Name</Card.Title>
                              </div>
                            </div>
                          </div>


                          <div className='col-md-12'>
                            <div className='cardText'>
                              <p className='ad_address mb-0'><i className="fas fa-location-dot" title="location"></i> address, city, state</p>
                            </div>
                          </div>

                          <div className='col-md-12'>
                            <div className='cardText'>
                              <p className='ad_email mb-0'><i className="fa fa-envelope" title="email"></i> contact@demo.com</p>
                              <p className='ad_website mb-0'><i className="fa fa-globe" title="website"></i>
                                <a href="#" rel="noopener noreferrer"> www.demo.com</a>
                              </p>
                            </div>
                          </div>

                          <div className='col-md-12'>
                            <div className='ad_services my-1'>
                              <ul className='ad_serviceList'>
                                <li>Road Service</li>
                                <li>Electrical System</li>
                                <li>New Tires Sales</li>
                                <li>Fleet Acounts</li>
                              </ul>
                            </div>
                          </div>

                          <div className='col-md-12'>
                            <div className="ad_description">
                              <p>{plan.description}</p>
                            </div>
                          </div>
                        </Row>

                        <div className='row align-items-center plan_actions_column'>
                          <div className='new-ad-bottom col-md-12'>
                            <div className='bd_plan_contact text-center'>
                              <button className='btn' type="button"><i className="fa fa-phone" title="phone"></i> (123)-456-7890</button>
                            </div>
                          </div>

                          <div className='col-md-12'>
                            <div className="planPrice-style p-0">
                              <Button className='planBtn shine position-relative' variant="primary" onClick={() => handleShow(plan)}>Get {plan.name}</Button>
                            </div>
                          </div>
                        </div>

                      </Card.Body>
                    </Col>


                  </Row>



                </Card>
              </Col>
            ))}
          </Row>

          {/* Modal for contact details */}
          <Modal className="quote_modal" show={showModal} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>Get A Quote</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {selectedPlan && (
                <>
                  <div className="form_content">
                    <p className="mb-4">
                      Thank you for your interest in our <b>{selectedPlan.name} plan</b>. We’re thrilled to offer you our exceptional
                      services and are here to help you every step of the way!
                    </p>
                  </div>

                  <div className="quote_form">
                    <form onSubmit={handleSubmit}>
                      <Row>
                        <div className="col-md-6">
                          <div className="form-group cont_form">
                            <input
                              type="text"
                              className="form-control"
                              name="name"
                              value={formData.name}
                              onChange={handleChange}
                              placeholder="Your Name"
                              required
                              disabled={loading}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group cont_form">
                            <input
                              type="tel"
                              className="form-control"
                              name="phone"
                              value={formData.phone}
                              onChange={handleChange}
                              placeholder="Phone"
                              required
                              disabled={loading}
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group cont_form">
                            <input
                              type="email"
                              className="form-control"
                              name="email"
                              value={formData.email}
                              onChange={handleChange}
                              placeholder="Email"
                              required
                              disabled={loading}
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group cont_form">
                            <textarea
                              className="form-control h-auto"
                              rows="3"
                              cols="50"
                              name="formMessage"
                              value={formData.formMessage}
                              onChange={handleChange}
                              placeholder="Write a message"
                              required
                              disabled={loading}
                            />
                          </div>
                        </div>

                        <div className="col-md-12">
                          {message.text && (
                            <Alert variant={message.variant} className="mt-0 py-2 text-center">
                              {message.text}
                            </Alert>
                          )}
                          <div className="form_btn mt-1">
                            <button type="submit" className="btn w-100" disabled={loading}>
                              {loading ? (
                                <>
                                  <Spinner animation="border" size="sm" role="status" className="me-2" />
                                  Sending...
                                </>
                              ) : (
                                'Submit'
                              )}
                            </button>
                          </div>
                        </div>
                      </Row>
                    </form>
                  </div>
                </>
              )}
            </Modal.Body>
          </Modal>
        </Container>
      </section>
    </>
  );
};

export default Plans;
